/*
 * Simplified version of the AdaliaMeLocation component for 2022 mobile app.
 * Also works in browser but doesn't include a map.
 */
import React from "react";
import Helpers from './helpers.jsx'
import Setting from "./setting.jsx";
import Base from './base.jsx'; 
import {
  DataType,
  castDataType,
  Mode,
} from "../common.jsx";
import { Button } from "../../bootstrap/index.jsx";
import { FaIcon } from "../../common/Icons.jsx";

export default class AdaliaMeLocationMobile extends Base {
  static get CATEGORY() {
    return "question";
  }

  static get TYPE() {
    return "adalia_me_location_mobile";
  }

  static icon() {
    return <i className="fa fa-map-marker"></i>;
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'field_default_label',
      help: null,
    };
  }

  static defaultContent(language) {
    const fieldName = "field_" + Helpers.randomString();

    return Object.assign(super.defaultContent(language), {
      label: 'label',
      name: fieldName,
      reportKey: '',
      help: 'help',
      required: false,
      label_hidden: false,
    });
  }

  constructor(props) {
    super(props);

    this.state = {
        ...this.state,
        latitude: [Mode.FILL, Mode.VIEW].includes(props.mode) ? this.getAnswer().latitude : [],
        longitude: [Mode.FILL, Mode.VIEW].includes(props.mode) ? this.getAnswer().longitude : [],
    };
  }

  renderSettings() {
    return (
      <div>
        <Setting.Checkbox name="required" label={I18n.t('field_required', {scope: 'fe'})} value={this.props.content.required} onChange={this.updateSettings} />
        <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
        <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
        <Setting.LongTextField name="help" label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings} />
        {this.props.externalEntityLinkingCallback &&
          <Setting.ExternalEntityLinker 
            name="externalEntityAccessor" 
            label={I18n.t('field_external_entity_accessor', {scope: 'fe'})} 
            value={this.props.content.externalEntityAccessor} 
            onChange={this.updateSettings} 
            description={I18n.t('field_external_entity_accessor_description', {scope: 'fe'})} 
            externalEntityLinkingCallback={this.props.externalEntityLinkingCallback} 
            endpoint={this.props.content.endpoint}
            parent={this.props.content.parentExternalEntityAccessor}
          />
        }
        <Setting.TextField
          name="reportKey"
          label={I18n.t('field_report_key', {scope: 'fe'})}
          value={this.props.content.reportKey}
          description={I18n.t('field_report_key_description', {scope: 'fe'})}
          {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
        />
        <Setting.Checkbox name="lockEdit" label={I18n.t('field_lock_edit', {scope: 'fe'})} description={I18n.t('field_lock_edit_description', {scope: 'fe'})} value={this.props.content.lockEdit} onChange={this.updateSettings} />
        {AppConfig.features.form_prefill ? <Setting.Checkbox name="lockEditWhenPrefilled" label={I18n.t('field_lock_edit_when_prefilled', {scope: 'fe'})} description={I18n.t('field_lock_edit_when_prefilled_description', {scope: 'fe'})} value={this.props.content.lockEditWhenPrefilled} onChange={this.updateSettings} /> : null}
        <Setting.Checkbox
          name="containsSensitiveInformation"
          label={I18n.t('field_contains_sensitive_information', {scope: 'fe'})}
          description={I18n.t('field_contains_sensitive_information_description', {scope: 'fe'})}
          value={this.props.content.containsSensitiveInformation}
          {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
        />
      </div>
    );
  }

  beforeUpdateSettings(content) {
    content.required = castDataType(content.required, DataType.BOOLEAN);
    content.label_hidden = castDataType(content.label_hidden, DataType.BOOLEAN);
    content.lockEditWhenPrefilled = castDataType(content.lockEditWhenPrefilled, DataType.BOOLEAN);
    content.lockEdit = castDataType(content.lockEdit, DataType.BOOLEAN);
  }


  handleLocationClick = () => {
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        this.onChange(coords.latitude, coords.longitude);
      },
      (error) => console.error("Error: Failed to retrieve location!", error)
    );
  };

  onChange = (latitude, longitude) => {
    this.setState({ latitude, longitude }, this.updateAnswer);
  };

  renderView() {
    return (
      <div name={this.fullFieldName(true)}>
        <div>
          <input type="hidden" name="latitude" value={this.state.latitude} />
          <input type="hidden" name="longitude" value={this.state.longitude} />
          <label  className={this.props.content.label_hidden ? 'hidden-label': ''}>
          <span className="field-label">{this.getText('label')}</span>
          </label>
          {this.props.content.required ? <span className='required-field'> *</span> : null}
          {this.helpIcon()}
          <p>Latitude: {this.state.latitude}</p>
          <p>Longitude: {this.state.longitude}</p>
        </div>
        <div className="mt-2">
          <Button elemType="button" onClick={this.handleLocationClick}>
            <FaIcon type="map-marker" /> {I18n.t("use_my_location", { scope: "fe" })}
          </Button>
        </div>
      </div>
    );
  }
}
